import React from "react"
import CustomerDataType from "./CustomerDataType";

class CustomersDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.length > 0) {
      return this.renderCustomers(this.props.data);
    } else {
      return (<span className="none">{I18n.t('none')}</span>);
    }
  }

  renderCustomers(customers) {
    var self = this;

    var customer_links = customers.map(function (customer) {
      if (self.props.settingsUserRole) {
        customer.actions = customer.all_data_table_actions[self.props.settingsUserRole.privilege];
      }

      return <div key={customer.id}><CustomerDataType data={customer} /></div>
    });


    return (
      <div>{customer_links}</div>
    );
  }

};

export default CustomersDataType